import { Flex, Group } from '#core/components';
import { SearchBar } from '#features/search/v2/components';
import { Logo } from './Logo';
import { ProfileButton } from './ProfileButton';

import styles from './Header.module.css';

export const Header = () => {
  return (
    <Flex className={styles.header}>
      <Group className={styles.left}>
        <Logo />
      </Group>
      <Group className={styles.right}>
        <SearchBar />
        <ProfileButton />
      </Group>
    </Flex>
  );
};
